import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  class: "centered w100",
  style: {"padding-top":"10px"}
}
const _hoisted_2 = {
  class: "mc with_white_bg pad20 with_shadow rad20",
  style: {"max-width":"600px","width":"60%"}
}
const _hoisted_3 = {
  key: 0,
  class: "underline text-left",
  style: {"padding-left":"10px","color":"#15c"}
}
const _hoisted_4 = {
  key: 1,
  class: "kaigyo text-left mt10 fs13",
  style: {"padding-left":"10px"}
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MailPreviewPartsEditContent = _resolveComponent("MailPreviewPartsEditContent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_MailPreviewPartsEditContent, { onAddMessage: _ctx.addMessage }, null, 8, ["onAddMessage"]),
      (_ctx.showButton)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.buttonName()), 1))
        : _createCommentVNode("", true),
      (_ctx.showSignature)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("span", null, _toDisplayString(_ctx.rm.user_setting.signature_text), 1)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}